import { render, staticRenderFns } from "./ChatForwardModal.vue?vue&type=template&id=346f54d2&"
import script from "./ChatForwardModal.vue?vue&type=script&lang=js&"
export * from "./ChatForwardModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatForwardModal.vue?vue&type=style&index=0&id=346f54d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports